import { Button, IconInput, Member, SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

import { usersArray } from "assets/data/usersData";
import { useState } from "react";
import { Link } from "react-router-dom";

export type CommunityMembersProps = CustomComponentProps & {
    setShowMembers: React.Dispatch<React.SetStateAction<boolean>>;
    showAdmins: boolean;
    setShowAdmins: React.Dispatch<React.SetStateAction<boolean>>;
    hideArrow?: boolean;
};

const CommunityMembers = ({
    setShowMembers,
    showAdmins,
    setShowAdmins,
    hideArrow = false
}: CommunityMembersProps) => {
    const [filterValue, setFilterValue] = useState("");
    // const [showAdmins, setShowAdmins] = useState(showCAdmins);

    const members = usersArray.filter((member, i) => {
        if (i % 2) {
            return member;
        }
    });
    const admins = usersArray.filter((member, i) => {
        if (i % 2 == 0) {
            return member;
        }
    });
    return (
        <div className="profile-followers-div">
            <div className="profile-name-container d-flex flex-j-between flex-a-center gap-10">
                <div className="d-flex flex-j-start flex-a-center gap-10">
                    {!hideArrow ? (
                        <div onClick={() => setShowMembers(false)}>
                            <SVG svg="arrow-left" size={24} />
                        </div>
                    ) : (
                        <Link to="/communities/@news">
                            <SVG svg="arrow-left" size={24} />
                        </Link>
                    )}
                    <div className="subheader-middle">
                        <h2 className="white-text">News Community</h2>
                    </div>
                </div>
                <div>
                    <IconInput
                        value={filterValue}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setFilterValue(e.target.value)}
                        rounded
                    />
                </div>
            </div>
            <div className="profile-followers-card card mt-20">
                <ul className="profile-followers-tabs-ul w-full d-flex flex-j-between flex-a-center">
                    <li
                        className={`${!showAdmins ? "is-active" : ""}  profile-followers-tabs-li cursor-pointer`}
                        onClick={() => setShowAdmins(false)}
                        //   onclick="togglePostIncident('post')"
                    >
                        <span className="white-text">Members</span>
                    </li>
                    <li
                        id="incident-tab-li"
                        className={`${showAdmins ? "is-active" : ""}  profile-followers-tabs-li cursor-pointer`}
                        onClick={() => setShowAdmins(true)}
                    >
                        <span className="white-text">Admins</span>
                    </li>
                </ul>
                <div
                    className={` profile-followers-container${showAdmins ? " is-hidden" : ""}  pt-20 pl-20 pr-20 pb-20 d-flex flex-col flex-j-between`}
                >
                    <div>
                        {members.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                        {members.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                        {members.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                        {members.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                        {members.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                    </div>
                    <div className="mb-10 d-flex flex-j-center  w-full">
                        <Button text="show More" color="" rounded />
                    </div>
                </div>
                <div
                    className={`profile-followers-container profile-indirect-followers-container${!showAdmins ? " is-hidden" : ""} pt-20 pl-20 pr-20 pb-20 d-flex flex-col flex-j-between`}
                >
                    <div>
                        {admins.map((member) => (
                            <Member
                                user={member}
                                key={member.id}
                                className="mb-20"
                            />
                        ))}
                    </div>
                    <div className="mb-10 d-flex flex-j-center w-full">
                        <Button text="show More" color="" rounded />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunityMembers;
